/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminSingleSectionData } from '@INTERFACES/admin-api/sections';

export interface PreviewSectionBaseTextModalState {
    isOpen: boolean;

    data: {
        canGenerateDocument: boolean;

        sectionData: AdminSingleSectionData;
    } | null;
}

export interface PreviewSectionBaseTextModalDispatchParams {
    canGenerateDocument: boolean;

    sectionData: AdminSingleSectionData;
}

const initialState: PreviewSectionBaseTextModalState = {
    isOpen: false,

    data: null,
};

export const previewSectionBaseTextModalSlice = createSlice({
    name: 'preview-section-base-text-modal',
    initialState,
    reducers: {
        open(state: PreviewSectionBaseTextModalState, action: PayloadAction<PreviewSectionBaseTextModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: PreviewSectionBaseTextModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});
